import React, { useState, useCallback, useEffect } from 'react'
import { Row, Col, Input, Form } from 'antd'
import PropTypes from 'prop-types'
// Local Files
import FiltersLayout from '../component/FiltersLayout'
import AddMore from '../component/AddMore'
import TagGroup from '../../../components/TagGroup'
import HandleInputTags from '../../../helpers/HandleInputTagsHelpers'
import { setIsOpen } from '../helpers/actionHelpers'
import FiltersCount from '../component/FiltersCount'
import { AddButton } from './styled'
import Title from 'antd/lib/typography/Title'

const Company = ({ existedFilters, setExistedFilters }) => {
  const [values, setValues] = useState({
    companyValue: '',
    excludeCompanyValue: '',
    industryValue: '',
    excludeIndustryValue: '',
    company: [],
    excludedCompany: [],
    industry: [],
    excludedIndustry: [],
    isExcludeCompany: false,
    isExcludeIndustry: false,
    isOpen: false
  })

  // 🔹 Handle Add for Company/Industry
  const handleAdd = useCallback(
    (activeInputValue, activeInput) => {
      if (!values[activeInputValue]) return

      const tags = HandleInputTags(activeInputValue, activeInput, values)
      if (tags.length > 0 && values[activeInputValue]) {
        const updatedValues = {
          ...values,
          [activeInput]: tags,
          [activeInputValue]: '',
          isExcludeCompany: false,
          isExcludeIndustry: false
        }
        setValues(updatedValues)

        const updatedCompanyFilter = {
          ...existedFilters?.company,
          company: {
            ...(updatedValues.company?.length ? { shouldHave: updatedValues.company } : {}),
            ...(updatedValues.excludedCompany?.length
              ? { mustNotHave: updatedValues.excludedCompany }
              : {})
          },
          industry: {
            ...(updatedValues.industry?.length ? { shouldHave: updatedValues.industry } : {}),
            ...(updatedValues.excludedIndustry?.length
              ? { mustNotHave: updatedValues.excludedIndustry }
              : {})
          }
        }

        setExistedFilters({
          ...existedFilters,
          company: updatedCompanyFilter
        })
      }
    },
    [values, existedFilters, setExistedFilters]
  )

  // 🔹 Handle Delete
  const handleDelete = (tags, activeTagsType) => {
    const updatedValues = { ...values, [activeTagsType]: tags }
    setValues(updatedValues)

    const updatedCompanyFilter = {
      ...existedFilters.company,
      company: {
        ...(updatedValues.company?.length ? { shouldHave: updatedValues.company } : {}),
        ...(updatedValues.excludedCompany?.length
          ? { mustNotHave: updatedValues.excludedCompany }
          : {})
      },
      industry: {
        ...(updatedValues.industry?.length ? { shouldHave: updatedValues.industry } : {}),
        ...(updatedValues.excludedIndustry?.length
          ? { mustNotHave: updatedValues.excludedIndustry }
          : {})
      }
    }

    setExistedFilters({
      ...existedFilters,
      company: updatedCompanyFilter
    })
  }

  // 🔹 Clear Include/Exclude for Company/Industry
  const clearIncludeCompany = () => {
    setValues({ ...values, company: [] })
    const prev = existedFilters.company?.company || {}
    const { shouldHave, ...rest } = prev
    setExistedFilters({
      ...existedFilters,
      company: { ...existedFilters.company, company: rest }
    })
  }

  const clearExcludeCompany = () => {
    setValues({ ...values, excludedCompany: [] })
    const prev = existedFilters.company?.company || {}
    const { mustNotHave, ...rest } = prev
    setExistedFilters({
      ...existedFilters,
      company: { ...existedFilters.company, company: rest }
    })
  }

  const clearIncludeIndustry = () => {
    setValues({ ...values, industry: [] })
    const prev = existedFilters.company?.industry || {}
    const { shouldHave, ...rest } = prev
    setExistedFilters({
      ...existedFilters,
      company: { ...existedFilters.company, industry: rest }
    })
  }

  const clearExcludeIndustry = () => {
    setValues({ ...values, excludedIndustry: [] })
    const prev = existedFilters.company?.industry || {}
    const { mustNotHave, ...rest } = prev
    setExistedFilters({
      ...existedFilters,
      company: { ...existedFilters.company, industry: rest }
    })
  }

  // 🔹 Sync existing filters to local state
  useEffect(() => {
    setValues((prev) => ({
      ...prev,
      company: existedFilters?.company?.company?.shouldHave || [],
      excludedCompany: existedFilters?.company?.company?.mustNotHave || [],
      industry: existedFilters?.company?.industry?.shouldHave || [],
      excludedIndustry: existedFilters?.company?.industry?.mustNotHave || []
    }))
  }, [existedFilters])

  const emptyFields = [
    values.company,
    values.excludedCompany,
    values.industry,
    values.excludedIndustry
  ]

  return (
    <FiltersLayout
      title="COMPANY"
      setIsOpen={() => setIsOpen(setValues, values)}
      isOpen={values.isOpen}
    >
      {emptyFields.every((field) => field.length === 0) && !values.isOpen && (
        <Title level={4} disabled style={{ fontSize: '14px', marginBottom: 0 }}>
          All Companies
        </Title>
      )}
      {/* Company Section */}
      <Row>
        <Form className="block-level-form">
          {(values.company.length > 0 || values.isOpen) && (
            <FiltersCount
              title="Company"
              ExcludeField={values.company}
              clearExcludeFilters={clearIncludeCompany}
            />
          )}
          <Row className="tags-label filters-tags">
            <TagGroup tags={values.company} onDelete={handleDelete} activeTagsType="company" />
          </Row>
          {values.isOpen && (
            <Form.Item style={{ position: 'relative' }}>
              <Input
                name="companyValue"
                placeholder="Add Company"
                value={values.companyValue}
                onChange={(e) => setValues({ ...values, [e.target.name]: e.target.value })}
                onPressEnter={() => handleAdd('companyValue', 'company')}
              />
              <AddButton
                onClick={() => handleAdd('companyValue', 'company')}
                noBorder
                maxWidth
                absolute
                noBackground
                disabled={!values.companyValue}
              >
                Add
              </AddButton>
            </Form.Item>
          )}
        </Form>
      </Row>

      <Col className={values.excludedCompany.length || values.isOpen ? 'exclude-tags-area' : ''}>
        {(values.excludedCompany.length > 0 || values.isOpen) && (
          <FiltersCount
            title="Exclude Company"
            ExcludeField={values.excludedCompany}
            clearExcludeFilters={clearExcludeCompany}
          />
        )}
        <Row>
          <TagGroup
            tags={values.excludedCompany}
            isExlude={values.excludedCompany && true}
            onDelete={handleDelete}
            activeTagsType="excludedCompany"
          />
        </Row>
        {values.isExcludeCompany && values.isOpen && (
          <Row style={{ position: 'relative' }}>
            <Input
              name="excludeCompanyValue"
              placeholder="Exclude Company"
              value={values.excludeCompanyValue}
              onChange={(e) => setValues({ ...values, [e.target.name]: e.target.value })}
              onPressEnter={() => handleAdd('excludeCompanyValue', 'excludedCompany')}
            />
            <AddButton
              onClick={() => handleAdd('excludeCompanyValue', 'excludedCompany')}
              noBorder
              maxWidth
              absolute
              noBackground
              disabled={!values.excludeCompanyValue}
            >
              Add
            </AddButton>
          </Row>
        )}
      </Col>

      {!values.isExcludeCompany && values.isOpen && (
        <AddMore
          title="Exclude Company"
          onClick={() => setValues({ ...values, isExcludeCompany: true })}
        />
      )}

      {/* Industry Section */}
      <Row className={values.industry.length > 0 || values.isOpen ? 'margin-top-row' : ''}>
        <Form className="block-level-form">
          {(values.industry.length > 0 || values.isOpen) && (
            <FiltersCount
              title="Industry"
              ExcludeField={values.industry}
              clearExcludeFilters={clearIncludeIndustry}
            />
          )}
          <Row className="tags-label filters-tags">
            <TagGroup tags={values.industry} onDelete={handleDelete} activeTagsType="industry" />
          </Row>
          {values.isOpen && (
            <Form.Item style={{ position: 'relative' }}>
              <Input
                name="industryValue"
                placeholder="Add Industry"
                value={values.industryValue}
                onChange={(e) => setValues({ ...values, [e.target.name]: e.target.value })}
                onPressEnter={() => handleAdd('industryValue', 'industry')}
              />
              <AddButton
                onClick={() => handleAdd('industryValue', 'industry')}
                noBorder
                maxWidth
                absolute
                noBackground
                disabled={!values.industryValue}
              >
                Add
              </AddButton>
            </Form.Item>
          )}
        </Form>
      </Row>

      <Col className={values.excludedIndustry.length || values.isOpen ? 'exclude-tags-area' : ''}>
        {(values.excludedIndustry.length > 0 || values.isOpen) && (
          <FiltersCount
            title="Exclude Industry"
            ExcludeField={values.excludedIndustry}
            clearExcludeFilters={clearExcludeIndustry}
          />
        )}
        <Row>
          <TagGroup
            tags={values.excludedIndustry}
            isExlude={values.excludedIndustry && true}
            onDelete={handleDelete}
            activeTagsType="excludedIndustry"
          />
        </Row>
        {values.isExcludeIndustry && values.isOpen && (
          <Row style={{ position: 'relative' }}>
            <Input
              name="excludeIndustryValue"
              placeholder="Exclude Industry"
              value={values.excludeIndustryValue}
              onChange={(e) => setValues({ ...values, [e.target.name]: e.target.value })}
              onPressEnter={() => handleAdd('excludeIndustryValue', 'excludedIndustry')}
            />
            <AddButton
              onClick={() => handleAdd('excludeIndustryValue', 'excludedIndustry')}
              noBorder
              maxWidth
              absolute
              noBackground
              disabled={!values.excludeIndustryValue}
            >
              Add
            </AddButton>
          </Row>
        )}
      </Col>

      {!values.isExcludeIndustry && values.isOpen && (
        <AddMore
          title="Exclude Industry"
          onClick={() => setValues({ ...values, isExcludeIndustry: true })}
        />
      )}
    </FiltersLayout>
  )
}

Company.propTypes = {
  existedFilters: PropTypes.object,
  setExistedFilters: PropTypes.func
}

export default Company
